import { useQuery } from '@tanstack/react-query';

const fetchSunData = async () => {
  const response = await fetch(
    'https://api.sunrise-sunset.org/json?lat=47.3923&lng=121.4001&formatted=0&tzid=America/Los_Angeles'
  );
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
};

export const useSunData = () => {
  const sunData = useQuery({
    queryKey: ['sun'],
    queryFn: () => fetchSunData(),
    // Stale after 24 hours
    staleTime: 2 * 60 * 60 * 24 * 1000,
  });

  if (sunData.isLoading || sunData.isError) {
    return sunData;
  } else {
    return {
      ...sunData,
      sunrise: new Date(sunData.data.results.sunrise),
      sunset: new Date(sunData.data.results.sunset),
    };
  }
};
